import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { trainingCertificatesActions as actions, notificationActions } from '../actions';
import { trainingCertificateService } from '../services';

/* Add Training Certificate */
function* handleAddTrainingCertificateRequest() {
    const action = yield take(actions.addTrainingCertificateRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(trainingCertificateService.addTrainingCertificate, dataParams);
        if (res.isError) {
            yield put(actions.addTrainingCertificateError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addTrainingCertificateSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addTrainingCertificateError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Training Certificates */
function* handleGetTrainingCertificatesRequest() {
    const action = yield take(actions.getTrainingCertificatesRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(trainingCertificateService.getTrainingCertificates, dataParams);

        if (res.isError) {
            yield put(actions.getTrainingCertificatesError(res));

        } else {
            yield put(actions.getTrainingCertificatesSuccess(res));
        }

    } catch (error) {
        yield put(actions.getTrainingCertificatesError());
    }
}


/* Update Training Certificate */
function* handleUpdateTrainingCertificateRequest() {
    const action = yield take(actions.updateTrainingCertificateRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(trainingCertificateService.updateTrainingCertificate, dataParams);
        if (res.isError) {
            yield put(actions.updateTrainingCertificateError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateTrainingCertificateSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateTrainingCertificateError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Delete Training Certificate */
function* handleDeleteTrainingCertificateRequest() {
    const action = yield take(actions.deleteTrainingCertificateRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(trainingCertificateService.deleteTrainingCertificate, dataParams);
        if (res.isError) {
            yield put(actions.deleteTrainingCertificateError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteTrainingCertificateSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteTrainingCertificateError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}


/* Delete Training Certificate */ 
function* handleGetAllTrainingCertificatesRequest() {
    const action = yield take(actions.getAllTrainingCertificatesRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(trainingCertificateService.getAllTrainingCertificates, dataParams);
        if (res.isError) {
            yield put(actions.getAllTrainingCertificatesError(res));
        } else {
            yield put(actions.getAllTrainingCertificatesSuccess(res));
        }
    } catch (error) {
        yield put(actions.getAllTrainingCertificatesError());
    }
}


/* -----------Watchers------------- */
function* handleAddTrainingCertificateWatcher() {
    yield takeEvery(
        actions.addTrainingCertificateRequest,
        handleAddTrainingCertificateRequest,
    );
}

function* handleGetTrainingCertificatesWatcher() {
    yield takeEvery(
        actions.getTrainingCertificatesRequest,
        handleGetTrainingCertificatesRequest,
    );
}

function* handleUpdateTrainingCertificateWatcher() {
    yield takeEvery(
        actions.updateTrainingCertificateRequest,
        handleUpdateTrainingCertificateRequest,
    );
}

function* handleDeleteTrainingCertificateWatcher() {
    yield takeEvery(
        actions.deleteTrainingCertificateRequest,
        handleDeleteTrainingCertificateRequest,
    );
}

function* handleGetAllTrainingCertificatesWatcher() {
    yield takeEvery(
        actions.getAllTrainingCertificatesRequest,
        handleGetAllTrainingCertificatesRequest,
    );
}





function* rootTrainingCertificatesSaga() {
    yield all([
        handleAddTrainingCertificateRequest(),
        handleAddTrainingCertificateWatcher(),

        handleGetTrainingCertificatesRequest(),
        handleGetTrainingCertificatesWatcher(),

        handleUpdateTrainingCertificateRequest(),
        handleUpdateTrainingCertificateWatcher(),

        handleDeleteTrainingCertificateRequest(),
        handleDeleteTrainingCertificateWatcher(),

        handleGetAllTrainingCertificatesRequest(),
        handleGetAllTrainingCertificatesWatcher(),

    ]);
}

export default rootTrainingCertificatesSaga;
